import React, { useState, useEffect } from "react";
import { getRequestRow } from "../../apiWrapper";

const ExportGoalsModal = ({ studentid, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("exportDateRange") || "{}");
    if (saved.start) setStartDate(saved.start);
    if (saved.end) setEndDate(saved.end);
  }, []);

  const handleExport = async () => {
    if (!startDate || !endDate) {
      alert("期間を選択してください");
      return;
    }
  
    localStorage.setItem("exportDateRange", JSON.stringify({ start: startDate, end: endDate }));
  
    const url = `student_goals/export?studentid=${studentid}&start_date=${startDate}&end_date=${endDate}`;
  
    try {
      const response = await getRequestRow(url); // 認証付きfetch
      if (!response.ok) {
        const data = await response.json();
        alert(data?.error || "出力に失敗しました");
        return;
      }
  
      const contentDisposition = response.headers.get("Content-Disposition");
      let fileName = "student_goals_export.xlsx";
  
      if (contentDisposition) {
        const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }
  
      const blob = await response.blob();
      const fileURL = window.URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);
      onClose();
    } catch (err) {
      console.error("❌ Excel出力エラー:", err);
      alert("出力中にエラーが発生しました");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-[90%] max-w-md shadow-lg">
        <h2 className="text-lg font-semibold mb-4">期間を指定して出力</h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">開始日</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">終了日</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full border rounded px-3 py-2 text-sm"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">キャンセル</button>
          <button onClick={handleExport} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">出力</button>
        </div>
      </div>
    </div>
  );
};

export default ExportGoalsModal;
